import { render, staticRenderFns } from "./PermissionTemplate.vue?vue&type=template&id=1767bf40&"
import script from "./PermissionTemplate.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports